export function warn(message) {
    if (process.env.NODE_ENV !== "production") {
        console.warn(`[react-router-typesafe-routes] ${message}`);
    }
}
